import { ApiAction, initialApiState, ApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'

export interface BouncedReceiptTotalIntervalState extends ApiState {
  total?: number
}

const BouncedReceiptTotalInterval = (state: BouncedReceiptTotalIntervalState = initialApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<BouncedReceiptTotalIntervalState>('BOUNCED_RECEIPT_TOTALS')(state, action)
  }
}

export default BouncedReceiptTotalInterval
